export function tryParseBool(value: any): boolean | undefined {
    if (value === undefined) {
        return undefined;
    }

    try {
        const parsedValue = JSON.parse(value);
        return typeof parsedValue === 'boolean' ? parsedValue : undefined;
    } catch {
        return undefined;
    }
}
